import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

import colors from '@app/constants/colors';

const GradientSection = ({ children }) => (
  <GradientSectionContainer>
    <GradientBlock>{children}</GradientBlock>
  </GradientSectionContainer>
);

GradientSection.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.element,
    PropTypes.arrayOf(PropTypes.element),
  ]),
};

GradientSection.defaultProps = {
  children: null,
};

export default GradientSection;

const GradientSectionContainer = styled.section`
  width: 100%;
  text-align: center;  
  padding: 40px 0;
  
  @media (max-width: 979px) {
    padding: 20px 0 40px;
  }  
`;

const GradientBlock = styled.div`
  background: linear-gradient(0deg,  ${colors.BEESWAX} 0%, ${colors.ENERGY_YELLOW} 100%);
  padding: 20px 0 50px;
  color: ${colors.INTERNATIONAL_ORANGE};
  
  @media (max-width: 979px) {
    padding: 20px 0 40px;
  }  
`;
